import '../index.css'

export default function PrivacyPolicy() {
    return (
        <div className="privacy-policy--container">
            <h1>Privacy Policy</h1>
            <p><b>Version from: September 07, 2023</b></p>
            <p><b>Cold-Wallet</b> (hereinafter <b>"we"</b> , <b>"us"</b> , <b>"our"</b> ) respects and understands the
                importance of protecting your private data, and is committed to protecting your privacy rights to the
                maximum extent possible.</p>
            <p>Protecting user data and using it only in the way users expect us to do is our highest priority. This
                Privacy Policy is intended to inform you about the collection and processing of your personal data and
                your rights in relation to this processing under applicable data protection legislation.</p>
            <p>We are not the owner of your personal data, nevertheless we are the person who determines the purpose of
                processing your personal data, establishes the composition of this data and the procedures for its
                processing.</p>
            <p>By using our website (https://cold-wallet.app/), and/or Cold-Wallet mobile applications (hereinafter
                collectively referred to as the <b>"Services"</b> ), you accept this Policy and give us your consent to
                process your personal data as described in this document.
            </p>
            <h2>How and what data we collect</h2>
            <p>We may have access to information that you voluntarily provide to us (or our partners and other third
                parties) when using our Services, that you voluntarily provide to us when you communicate with us by
                email or otherwise that we received about you from our partners and other third parties. Such
                information may include: request type, apple id, analytical information about your use of the Services,
                bank token in encrypted form, bank account IDs, cryptocurrency exchange api-keys, api-secrets,
                pass-phrases, passwords, sub-account ids, any data that can be received by your keys, other financial
                assets data that you provide to us, including currencies and amounts, and other additional information
                you provide.</p>
            <h2>How we use your data</h2>
            <p>We will use the information you provide to:</p>
            <ul>
                <li><p>providing the Services to you;</p></li>
                <li><p>improving our Services;</p></li>
            </ul>
            <h2>On what basis do we process your data?</h2>
            <p>We rely on your consent when we process your personal data to provide you with the Services, to
                optimize and improve our Services, and to communicate with you.</p>
            <h2>Security of your data</h2>
            <p>We take appropriate organizational and technical measures during the processing of your data to protect
                them from unauthorized access, alteration, disclosure or destruction. Personal data that we process for
                any purpose will not be retained for longer than is necessary for that purpose, including to comply with
                legal requirements.</p>
            <h2>Data dissemination</h2>
            <p>Sometimes we need to share your personal data with others to ensure the proper provision of the Services.
                In such cases, we will comply with applicable laws aimed at ensuring the confidentiality of your
                personal data. By using our Services, you consent to sharing the information we collect about you,
                including personal data, with any of our partners who ensure the proper provision of the Services.</p>
            <p>We may share your information with the following recipients: service providers, partners, for the
                purposes described in this Policy.</p>
            <p>We may collect analytics or use third-party analytics tools to help us measure trends in traffic and
                usage of the Services, and to understand the demographics and behaviors of our users, how users interact
                with our Services.</p>
            <h2>Links to third-party websites and applications</h2>
            <p>Our Services may contain links to third-party websites and mobile applications. We are not responsible
                for the content of such third-party websites and mobile applications.</p>
            <h2>Changes to the Policy</h2>
            <p>We may update this Policy from time to time by posting a new version on our website. Any changes we make
                to this Policy will be posted on our website so that you are always aware of what information we
                collect, how we may use that information, and under what circumstances we may disclose it to third
                parties.</p>
            <h2>Data storage</h2>
            <p>We ensure that personal data is stored encrypted within the local storage and session storage of your
                web-browser on your device.</p>
            <h2>Your rights</h2>
            <p>Your main rights regarding our processing of your personal data include:</p>
            <ol>
                <li><p>
                    know about the sources of collection, the location of your personal data, the purpose of their
                    processing, the location of the owner or controller of personal data;
                </p></li>
                <li><p>
                    receive information about the conditions for providing access to personal data, in particular
                    information about third parties to whom personal data is transferred;
                </p></li>
                <li><p>to access your personal data;</p></li>
                <li><p>receive an answer about how personal data is being processed;</p></li>
                <li><p>
                    present a reasoned demand to change or destroy your personal data, if these data are processed
                    illegally or are unreliable;
                </p></li>
                <li><p>
                    to protect your personal data from illegal processing and accidental loss, destruction, damage, as
                    well as to protect against providing information that is unreliable or disgraces the honor, dignity
                    and business reputation of a natural person;
                </p></li>
            </ol>
            <p>You are free to contact <span>us</span> (see Contact Information section below). When you send us a
                request to exercise a right, please indicate the detailed subject of the request, the type of right
                exercised, and any other information to facilitate processing of your request.</p>
            <p>We will do our best to respond to your inquiries as quickly as possible or within a reasonable time frame
                taking into account the complexity of the request, but if we are processing a large number of inquiries,
                it may take us longer than you might expect to respond.</p>
            <h2>Contact Information</h2>
            <p>If you have any questions about this Policy, please contact <span>us</span> :</p>
            <address>Email: <a href="mailto:cold.wallet.app@gmail.com">cold.wallet.app@gmail.com</a></address>
        </div>
    )
}
